import {request, serviceUrl} from "@/utils/request";

// 获取空间树形结构
export function getSpaceTreeData(code, levelType) {
  return request({
    url: serviceUrl.spaceService + '/space/info/tree',
    params: {code, levelType}
  })
}

// 获取空间地理树形结构
export function getSpaceTree(levelType) {
  return request({
    url: serviceUrl.spaceService + '/space/info/tree/geography',
    params: {levelType}
  })
}

// 根据空间id获取空间信息
export function getSpaceInfoById(spaceId) {
  return request({
    params: {
      spaceId
    },
    url: serviceUrl.spaceService + '/space/info/'
  })
}

// 获取省份机房数
export function getProvinceSpace() {
  return request({
    url: serviceUrl.spaceService + '/space/info/getProvinceSpace'
  })
}

// 根据省市区标识获取机房数据
export function getSpaceByCityCodeAndLevel(cityCode, level) {
  return request({
    url: serviceUrl.spaceService + '/space/info/getSpaceByCityCodeAndLevel',
    params: {cityCode, level}
  })
}

// 获取空间下的所有子空间
export function getAllChildId(id) {
  return request({
    url: serviceUrl.spaceService + '/space/info/getAllChildId/' + id
  })
}

// 保存空间
export function save(params) {
  return request({
    method: 'post',
    url: serviceUrl.spaceService + '/space/info/save',
    data: params
  })
}

// 保存空间
export function saveByLevel(params) {
  return request({
    method: 'post',
    url: serviceUrl.spaceService + '/space/info/save/by/level',
    data: params
  })
}

// 根据空间id删除空间
export function deleteById(spaceId) {
  return request({
    method: 'DELETE',
    url: serviceUrl.spaceService + '/space/info/delete',
    params: {spaceId}
  })
}

// 传入一个数组
// 获取空间树 逻辑空间可被选中
export function getTree(tree) {
  // 返回的数组
  let treeList = [];
  for (let item of tree) {
    // 创建上级选项
    let param = {value: item.id, label: item.title};
    if (item.children != undefined) {
      // 给上级选项添加下级选项
      param.children = getTree(item.children);
    }
    treeList.push(param)
  }
  return treeList;
}

// 获取空间树 逻辑空间将无法选中
export function getTreeHaveDisabled(tree) {
  // 返回的数组
  let treeList = [];
  for (let item of tree) {
    // 创建上级选项
    let param = {value: item.id, label: item.title, disabled: item.type == 1};
    if (item.children != undefined) {
      // 给上级选项添加下级选项
      param.children = getTreeHaveDisabled(item.children);
    }
    treeList.push(param)
  }
  return treeList;
}

// 空间权限-列表查询
export function spaceAuthList(params) {
  return request({
    method: 'get',
    url: serviceUrl.spaceService + '/psychz/permission/listByOrgId',
    params: params
  })
}

// 空间权限-修改权限
export function updateSpaceAuth(data) {
  return request({
    method: 'post',
    url: serviceUrl.spaceService + '/psychz/permission/authorizedPsychz',
    data: data
  })
}

// 修改所有设备授权
export function updateAuthorizedAllSpace(orgId,isView) {
  return request({
    method: 'post',
    url: serviceUrl.spaceService + '/psychz/permission/updateAuthorizedAllSpace',
    params: {orgId,isView}
  })
}
